import DropdownFilter from "gatsby-theme-dettol/src/components/DropdownFilter/DropdownFilter"

import "./DropdownFilterOverride.scss"

export default DropdownFilter